"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.metaModules = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
exports.metaModules = (0, basic_1.applyBase)({
    cookies: {
        wrap: {
            position: 'fixed',
            bottom: '0',
            left: '0',
            right: '0',
            zIndex: '10',
            width: '100%',
            backgroundColor: 'bgMediumBlue',
            flexWrap: ['wrap', 'nowrap'],
            justifyContent: [null, 'space-between'],
            alignItems: 'center',
        },
        text: Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.LARGE), { pl: [4, 6], pr: 4, py: [3, 4], a: {
                color: 'primary',
            } }),
        acceptButton: {
            width: ['100%', 'auto'],
            flexShrink: '0',
            borderRadius: ['0px', 'default'],
            mr: [null, 6],
            letterSpacing: '0.8px',
        },
    },
});
//# sourceMappingURL=meta-modules.js.map